var map = {
	"./bg_hotel.jpg": "T6NR",
	"./bg_texture.png": "i8ev",
	"./bg_texture2.png": "DX2o",
	"./cover-abruzzo.jpg": "i5U+",
	"./ico_arrow.svg": "wOPL",
	"./ico_beach.svg": "P6cb",
	"./ico_bike.svg": "2Eq/",
	"./ico_calculator.svg": "h8j2",
	"./ico_calendar.svg": "8CEf",
	"./ico_facebook.svg": "zZpD",
	"./ico_facebook_white.svg": "8E3/",
	"./ico_food.svg": "1bWG",
	"./ico_games.svg": "7vkl",
	"./ico_instagram.svg": "t8ZT",
	"./ico_instagram_white.svg": "UzNY",
	"./ico_kids.svg": "4+eN",
	"./ico_mail_white.svg": "L9J0",
	"./ico_sand.svg": "kHF1",
	"./ico_tel_white.svg": "JSbD",
	"./ico_tripadvisor.svg": "1P5G",
	"./ico_tripadvisor_white.svg": "uxK2",
	"./logo.svg": "l42v",
	"./logo_holiday.png": "qdEV",
	"./logo_m.svg": "zOiW",
	"./logo_michelin.png": "71sM",
	"./logo_tci.png": "H37m",
	"./logo_tripadvisor.png": "QVj9",
	"./palm.png": "NWQ1",
	"./placeholder-lg.jpg": "EA+W",
	"./test.jpg": "Aa15",
	"./texture.png": "xWs6",
	"./waves.svg": "v3JD"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Erx1";